import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TagManagerUtils from '../../utils/TagManagerUtils';
import Input from '../common/input/Input';
import i18n from '../../config/I18n';
import { indicadorCurse, simularAction, obtenerDatosPersonaAction, solicitarCreditoAction, enviarDocumentoAction, updatePersonaAction, enviarSolicitudAction } from '../main/MainAction';
import { validarStepAction } from '../common/Step/StepsAction';
import { formatNumberUtils, esEmailValido, validarNumero, formatOnlyNumber } from '../../utils/FormatUtil';
import ModalErrorGenerico from '../common/Modal/ModalErrorGenerico';
// import Modal from '../common/Modal/Modal';
import loaderAction from '../common/loader/LoaderAction';
import Loader from '../common/loader/Loader';
import Button from '../common/button/Button';
import ButtonBase from '../common/button/ButtonBase';
import Alert from '../common/alert/alert';
import { ingresarEnfermedadPreexistenteAction, enfermedadSeleccionadaPorElSocio, obtenerListaDeEnfermedades } from '../common/enfermedadPreexistente/EnfermedadPreexistenteAction';
import InputFileUpper from '../common/InputFileUpper/InputFileUpper';
import icnVolverInicio from '../assets/svg/icnVolverInicio.svg';
import Checkbox from '../common/checkbox/Checkbox';
import Ejecutivo from '../common/ejecutivo/ejecutivo';
import ModalRechazo from '../rechazo/ModalRechazo';
import { ModalRechazoAction } from '../rechazo/rechazoAction'
import ModalDatosContacto from '../common/ModalDatosContacto/ModalDatosContacto'
import './Step.css';

class Documentos extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.solicitar = this.solicitar.bind(this);
    this.top = React.createRef();
    this.state = ({
      email: null,
      telefono: null,
      emailValido: false,
      telefonoValido: false,
      cargoDocumentos: false,
      comentario: '',
      autorizado: false,
      showEjecutivoDocumento: false,
      showEjecutivoNota: false,
      showModalDatosContacto: false,
      altaNueva: false,    
      opcional: " (Opcional) ",
    });
  }


  componentDidMount() {

    document.addEventListener('scroll', this.trackScrolling);
    this.irTop();
    const { idFlujoSocio, history, mostrarLoader, datosPersona } = this.props;
    this.setState({ altaNueva: datosPersona.altaNueva })

    if (idFlujoSocio === 1) {
      // this.listaDeEnfermedades();
      // VALIDO MAIL
      if (esEmailValido(datosPersona.email)) {
        this.setState({
          email: datosPersona.email,
          emailValido: true
        });
      } else {
        this.setState({
          email: datosPersona.email
        });
      };
      // VALIDO TELEFONO
      if (datosPersona.telefono.length === 9 && datosPersona.telefono.startsWith('*****') && validarNumero(datosPersona.telefono.slice(5, 9))) {
        this.setState({
          telefono: datosPersona.telefono,
          telefonoValido: true
        });
      } else {
        this.setState({
          telefono: datosPersona.telefono
        });
      };

      // TAG
      const { simulacion, simulacionEstado, wv } = this.props;
      if (simulacionEstado) {
        TagManagerUtils.globalTag({
          'event': 'vpv-privado',
          'page': '/tef/credito-distancia/detalle',
          'monto': simulacion.resultadoSimulacion.montoLiquido,
          'plazo': simulacion.resultadoSimulacion.plazo,
          'ambiente': wv ? 'app' : 'sitio'
        })
      }
      mostrarLoader(false);
    } else {
      history.push({ pathname: '/Page404' });
    }
  }

  trackScrolling = () => {

    const wrappedElementDocumentos = document.getElementById('alturaDocumentos');
    if (wrappedElementDocumentos) {
      const elementDocumentos = wrappedElementDocumentos.getBoundingClientRect();
      if (elementDocumentos.top - 60 < 200) {
        this.setState({ showEjecutivoDocumento: true, showEjecutivoNota: false })
      } else if (elementDocumentos.top - 60 > 200) {
        this.setState({ showEjecutivoDocumento: false, showEjecutivoNota: false })
      }
    }

    const wrappedElementNotas = document.getElementById('alturaNotas');
    if (wrappedElementNotas) {
      const elementNotas = wrappedElementNotas.getBoundingClientRect();
      if (elementNotas.top - 60 < 400) {
        this.setState({ showEjecutivoNota: true, showEjecutivoDocumento: false })
      } else if (elementNotas.top - 60 > 400) {
        this.setState({ showEjecutivoNota: false })
      }
    }

  };



  cancelarStep = (e) => {
    e.preventDefault();
    const { rechazar, wv } = this.props;
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/detalle',
      'eve-cat': 'Click',
      'eve-lab': 'Volver a inicio',
      'ambiente': wv ? 'app':'sitio'
    })
    // window.top.location.href = process.env.URL_PORTAL_PRIVADO;
    
    rechazar();
    TagManagerUtils.globalTag({
      'event': 'vpv-privado',
      'page': '/tef/credito-distancia/encuesta',
      'ambiente': wv ? 'app':'sitio'
    });
  }


  // IR A TOP
  irTop = () => {
    this.top.current.focus();
  }

  // CAMBIO DE DATO EN IMPUT NEWWWW PROYECT

  handleChange = (e) => {
    if (e.target) {
      const valor = e.target.value;
      if (e.target.name === "telefono") {
        const xValor = formatOnlyNumber(valor)
        if (xValor !== '' && validarNumero(xValor) && xValor.length === 9) {
          this.setState({ telefono: xValor, telefonoValido: true });
        } else if (validarNumero(xValor) && valor.length < 9) {
          this.setState({ telefono: xValor, telefonoValido: false });
        }
      }
      if (e.target.name === "email") {
        if (valor !== '' && esEmailValido(valor)) {
          this.setState({ email: valor, emailValido: true });
        } else {
          this.setState({ email: valor, emailValido: false });
        }
      }
      if (e.target.name === "comentarios") {
        this.setState({ comentario: valor })
      }
      if (e.target.name === "autorizacion") {
        const { autorizado } = this.state;
        this.setState({ autorizado: !autorizado })
      }
    }
  }



  // SE OBTIENE LISTA DE ENFERMEDADES

  listaDeEnfermedades = async () => {
    const { obtenerListaDeEnfermedadesPreExistentes } = this.props;
    await obtenerListaDeEnfermedadesPreExistentes();
  }

  // SE ENVIA LA SOLICITUD

  solicitar = async () => {

    // TAG
    const { wv } = this.props;
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': '/tef/credito-distancia/detalle',
      'eve-cat': 'Click',
      'eve-lab': 'Enviar Solicitud',
      'ambiente': wv ? 'app' : 'sitio'
    })

    const { documentosCargados, enviarDocumento, updatePersona, mostrarLoader, trackId, enviarSolicitud } = this.props;
    const { comentario, email, telefono } = this.state;
    const newDocumentosCargados = []
    for (let i = 0; i < documentosCargados.length; i += 1) {
      if(documentosCargados[i].file !== null)
        newDocumentosCargados.push({
          idTipoDocumento: documentosCargados[i].idTipoDocumento,
          extensionDocumento: documentosCargados[i].extension,
          base64: documentosCargados[i].file
        });
    }

    const datosPersona = { "email": email, "telefono": telefono }
    mostrarLoader(true);
    await updatePersona(trackId, datosPersona);
    const { datosPersonaUpdate } = this.props;
    if (datosPersonaUpdate) {
      // await enviarDocumento(trackId, newDocumentosCargados, comentario);
      const documentosPromesas = []
      for (let i = 0; i < newDocumentosCargados.length; i += 1) {
        documentosPromesas.push(enviarDocumento(trackId, newDocumentosCargados[i]));
      }
      Promise.all(documentosPromesas)
        .then(() => {
          const { enviarSolicitudDocumentosError } = this.props;
          if (!enviarSolicitudDocumentosError) {
            Promise.all([enviarSolicitud(trackId, comentario)])
              .then(() => {
                mostrarLoader(false);
                const { history, enviarSolicitudDocumentos } = this.props;
                if (enviarSolicitudDocumentos) {
                  history.push({ pathname: '/Evaluacion' });
                }
              })
          } else {
            mostrarLoader(false);
          }

        })
    }

  }

  mostrarModalDatosContacto = () => {
    const { showModalDatosContacto } = this.state;
    this.setState({ showModalDatosContacto: !showModalDatosContacto });
  }

  irSimular = () => {

    const { history, validaStep } = this.props;
    history.push({ pathname: '/Simulador' });
    validaStep(2, false);

  }
// altaNueva, se debe incluir la variable de alta nueva al momento de revisar los doc

  revisarDocumentos = () => {
    const { documentosCargados } = this.props;
    const { altaNueva } = this.state;
    const cond = !altaNueva ? documentosCargados.length - 1 : documentosCargados.length;
    for (let i = 0; i < cond; i += 1) {
      if (documentosCargados[i].file === null) {
        this.setState({ cargoDocumentos: false });
        return false
      }
    }
    this.setState({ cargoDocumentos: true });
    return true

  }

  imprimirDocumentos = (alta,list,o) => {
    let nombre;

    if(!alta){
        nombre = list.name;      
      if(list.id === 7){
        nombre = list.name+o;
      }
    }else{
      nombre = list.name;
    }
    return (
      <div className="InputFileUpper row d-flex justify-content-between align-items-center">
        <InputFileUpper
          inputName={nombre}
          inputMes={list.mes}
          htmlForTag="inputFile"
          nItems={list.id}
          estado={list.estado}
          file={list.file}
          errors={list.error}
          url={list.url}
          visorPDF={list.VisorPDF}
          eventChange={this.revisarDocumentos}
        />
      </div>
    );
  }

  render() {
    
    const {
      showLoader,
      modalErrorGenerico,
      simulacionEstado,
      simulacion,
      enviarSolicitudDocumentosError,
      documentosCargados,
      wv
    } = this.props;

    const {
      email,
      telefono,
      emailValido,
      telefonoValido,
      cargoDocumentos,
      autorizado,
      showEjecutivoDocumento,
      showEjecutivoNota,
      showModalDatosContacto,
      altaNueva,
      opcional
    } = this.state;

    return (
      <div className="container-fluid stepContainer documentos">
        <ModalRechazo idEtapa={3} />
        <div className="top">
          <Input type="text" name="top" reference={this.top} />
        </div>
        <ModalErrorGenerico visible={modalErrorGenerico} wv={wv} />
        {email != null && telefono != null && (
          <ModalDatosContacto
            isOpen={showModalDatosContacto}
            funcion={this.mostrarModalDatosContacto}
            telefono={telefono}
            email={email}
            solicitar={this.solicitar}
            handleChange={this.handleChange}
            emailValido={emailValido}
            telefonoValido={telefonoValido}
          />
        )}
        <div className="row">
          <div className="col-sm-3 offset-sm-1 simulador movile-off" />
          <div className="col-sm-12 col-md-7 col-lg-7">
            <div className={simulacionEstado === null ? "card movile-off" : "card movile-on"}>
              {simulacionEstado !== null && (
                <div className="container-fluid">
                  <div className="row resumenHighlight">
                    <div className="col-12 ptop10 pbottom10">
                      <div className="row">
                        <div className="col-12 col-sm-4 col-md-4">
                          <div className="row">
                            <div className="col-12">
                              {i18n.t('simulacion.montoBruto')}
                            </div>
                            <div className="col-12">
                              <h2>
                                <small>$</small>
                                {formatNumberUtils(simulacion.resultadoSimulacion.montoLiquido)}
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                          <div className="row">
                            <div className="col-12">
                              {i18n.t('simulacion.plazo')}
                            </div>
                            <div className="col-12">
                              <h2>
                                {formatNumberUtils(simulacion.resultadoSimulacion.plazo)}
                                <small>{` ${i18n.t('simulacion.meses')}`}</small>
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                          <div className="row">
                            <div className="col-12">
                              {i18n.t('simulacion.valorCuota')}
                            </div>
                            <div className="col-12">
                              <h2>
                                <small>$</small>
                                {formatNumberUtils(simulacion.resultadoSimulacion.valorCuota)}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div id="alturaDocumentos" className="row">
          <div className="col-sm-3 offset-sm-1 simulador movile-off">
            {showEjecutivoDocumento && (
              <Ejecutivo
                mensajesEnrriqusidos={[
                  {
                    mensaje: i18n.t('ejecutivos.documentos_doc_a'),
                    tipo: 'normal'
                  },
                  {
                    mensaje: i18n.t('ejecutivos.documentos_doc_b'),
                    tipo: 'strong'
                  },
                  {
                    mensaje: i18n.t('ejecutivos.documentos_doc_c'),
                    tipo: 'normal'
                  }
                ]}
                tipo="right"
              />
            )}
          </div>
          <div className="col-sm-12 col-md-7 col-lg-7">
            <div className="card mbottom20">
              <div className="col-12">
                <div className="card-header row">
                  <div className="col-12 txtAlignL pad5">
                    <h3 className=" txtBold mbottom0">{i18n.t('documentos.cardTitle_b')}</h3>
                    <p className="ptop0 pbottom20">{i18n.t('documentos.cardSubTitle_b')}</p>
                  </div>
                </div>
              </div>
              <div className="row">
             
                
                <div className="col-12">
                  {documentosCargados.map((list) => (                    
                    <div key={list.id} className={list.id % 2 ? "Impar" : "Par"}>
                     
                      {this.imprimirDocumentos(altaNueva,list,opcional)}



                    </div>  
                    ))} 
                </div>                             
              </div>
            </div>
          </div>
        </div>
        <div id="alturaNotas" className="row">
          <div className="col-sm-3 offset-sm-1 simulador movile-off">
            {cargoDocumentos && showEjecutivoNota && (
              <Ejecutivo
                mensajesEnrriqusidos={[
                  {
                    mensaje: i18n.t('ejecutivos.documentos_notas_a'),
                    tipo: 'strong'
                  },
                  {
                    mensaje: i18n.t('ejecutivos.documentos_notas_b'),
                    tipo: 'normal'
                  },
                  {
                    mensaje: i18n.t('ejecutivos.documentos_notas_c'),
                    tipo: 'strong'
                  }
                ]}
                tipo="right"
              />
            )}
          </div>
          <div className="col-sm-12 col-md-7 col-lg-7">
            {cargoDocumentos && (
              <div className="card mbottom20 terminosCondiciones">
                <div className="card-body row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <h3 className="txtBold mbottom0 mtop0">{i18n.t('documentos.terminosCondicionesTitle')}</h3>
                    <p>{i18n.t('documentos.item_a')}</p>
                    <p>{i18n.t('documentos.item_c')}</p>
                    <p>
                      {i18n.t('documentos.item_ba')}
                      <strong>{i18n.t('documentos.item_bb')}</strong>
                      {i18n.t('documentos.item_bc')}
                    </p>
                    <div>
                      <Checkbox
                        // checkboxValue={autorizado}
                        checkboxName={i18n.t('documentos.autorizo')}
                        checkboxStatus={autorizado}
                        nameCheck="autorizacion"
                        checkboxFunction={(e) => { this.handleChange(e) }}
                      // checkboxEnable={!enable}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!cargoDocumentos && (
              <Alert
                mensajesEnrriqusidos={[
                  {
                    mensaje: i18n.t('documentos.AlertDocumentos_a'),
                    tipo: 'normal'
                  },
                  {
                    mensaje: i18n.t('documentos.AlertDocumentos_b'),
                    tipo: 'strong'
                  },
                  {
                    mensaje: i18n.t('documentos.AlertDocumentos_c'),
                    tipo: 'normal'
                  }
                ]}
                tipo="alert-danger"
                icons="iconAlertDanger"
              />
            )}
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-4" />
                  <div className={simulacionEstado === null ? "col-sm-4 movile-off" : "col-sm-4 movile-on"}>
                    <Button callClick={this.mostrarModalDatosContacto} buttonName={i18n.t('ui.enviarSolicitud')} enabled={!enviarSolicitudDocumentosError && cargoDocumentos && autorizado ? true : !true} />
                  </div>
                  <div className="col-sm-4 order-sm-first">
                    {!wv && <ButtonBase icons={icnVolverInicio} callClick={this.cancelarStep} css="botonCancelar" etiqueta={i18n.t('ui.volverInicio')} disabled />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-10 offset-sm-1 mtop10">
            <p>{i18n.t('ui.notaPie')}</p>
          </div>
        </div>
        <Loader visible={showLoader} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // stepActual: state.step.stepActual,
    // stepEstado: state.step.stepEstado,
    datosPersona: state.datosPersona.datosBasicosPersona,
    trackId: state.sessionUsuario.trackId,
    showLoader: state.loader.showLoader,
    modalErrorGenerico: state.modalError.showErrorGenerico,
    token: state.obtenerCampanaUsuario.token,
    idFlujoSocio: state.obtenerCampanaUsuario.idFlujo,
    // indicadorCurseSocio: state.indicadorCurse,
    simulacionEstado: state.simulacion.estado,
    simulacion: state.simulacion.detalleSimulacion,
    simulacionCodeError: state.simulacion.codeError,
    // listaFormatoLabel: state.listaDeEnfermedades.listaFormatoLabel,
    // enEjecucionAPIEnfermedadesPreExistentes: state.listaDeEnfermedades.enEjecucionAPIEnfermedadesPreExistentes,
    // listaEnfermedadSeleccionada: state.listaDeEnfermedades.enfermedades,
    enviarSolicitudDocumentos: state.enviarSolicitudDocumentos.enviarSolicitud,
    enviarSolicitudDocumentosError: state.enviarSolicitudDocumentos.errorEnviarSolicitud,
    documentosRecibidos: state.documentos.documentosRecibidos,
    documentosCargados: state.documentos.documentosCargados,
    datosPersonaUpdate: state.datosPersonaUpdate.updatedatosPersona,
    wv: state.webViuw.estado,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    validaStep: (actual, estado) => dispatch(validarStepAction(actual, estado)),
    mostrarLoader: (value) => dispatch(loaderAction(value)),
    obtenerIndicadorCurse: (token, curse) => dispatch(indicadorCurse(token, curse)),
    obtenerDatosBasicosPersona: (value) => dispatch(obtenerDatosPersonaAction(value)),
    simular: (solicitud, renta, cuotas, listaSeguros) => dispatch(simularAction(solicitud, renta, cuotas, listaSeguros)),
    obtenerListaDeEnfermedadesPreExistentes: (value) => dispatch(obtenerListaDeEnfermedades(value)),
    ingresarEnfermedad: (tieneEnfermedad) => dispatch(ingresarEnfermedadPreexistenteAction(tieneEnfermedad)),
    enfermedadSeleccionada: (value) => dispatch(enfermedadSeleccionadaPorElSocio(value)),
    solicitarCredito: (enfermedades, trackId) => dispatch(solicitarCreditoAction(enfermedades, trackId)),
    updatePersona: (trackId, enfermedades) => dispatch(updatePersonaAction(trackId, enfermedades)),
    enviarDocumento: (trackId, files) => dispatch(enviarDocumentoAction(trackId, files)),
    enviarSolicitud: (trackId, comentario) => dispatch(enviarSolicitudAction(trackId, comentario)),
    rechazar: () => dispatch(ModalRechazoAction(true))

  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Documentos));
